var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.75C3.62112 4.75 3.25776 4.6183 2.98985 4.38388C2.72194 4.14946 2.57143 3.83152 2.57143 3.5C2.57143 3.16848 2.72194 2.85054 2.98985 2.61612C3.25776 2.3817 3.62112 2.25 4 2.25C4.37888 2.25 4.74224 2.3817 5.01015 2.61612C5.27806 2.85054 5.42857 3.16848 5.42857 3.5C5.42857 3.66415 5.39162 3.8267 5.31983 3.97835C5.24804 4.13001 5.14281 4.26781 5.01015 4.38388C4.8775 4.49996 4.72001 4.59203 4.54669 4.65485C4.37337 4.71767 4.1876 4.75 4 4.75ZM4 0C2.93913 0 1.92172 0.368749 1.17157 1.02513C0.421427 1.6815 0 2.57174 0 3.5C0 6.125 4 10 4 10C4 10 8 6.125 8 3.5C8 2.57174 7.57857 1.6815 6.82843 1.02513C6.07828 0.368749 5.06087 0 4 0Z",
    fill: "#163B6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFilled);
export default __webpack_public_path__ + "static/media/pin_filled.dd59121906394371291850fb1d632bdb.svg";
export { ForwardRef as ReactComponent };